var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#af0800",
    d: "M6 4h1m1 0h1M4 5h1m1 0h3M4 6h2m2 0h1M4 7h1m3 0h1M4 8h1m3 0h1M5 9h3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f21c00",
    d: "M6 6h2M5 7h1m1 0h1M5 8h3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4c00",
    d: "M6 7h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire2A);
export default __webpack_public_path__ + "static/media/fire2a.dd108b76a222fc47542d4615381b90bf.svg";
export { ForwardRef as ReactComponent };